import { render, staticRenderFns } from "./paletteLabel.vue?vue&type=template&id=584cc1f8&scoped=true&"
import script from "./paletteLabel.vue?vue&type=script&lang=js&"
export * from "./paletteLabel.vue?vue&type=script&lang=js&"
import style0 from "./paletteLabel.vue?vue&type=style&index=0&id=584cc1f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584cc1f8",
  null
  
)

export default component.exports